import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGwGoodsGuigeListQuery } from '../../store/ReactWebSiteApi';
function GetWebGoodsSpec(props) {    
    const {data,isSuccess} = useGwGoodsGuigeListQuery({eowgg_eowg_id:props.eowgg_eowg_id},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eowgg_id:key,eowgg_name,} = item;
                    return item = {value:key,label:eowgg_name,}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                                    onChange={(_,f) => {
                    props.onChange(f.value,f.label,f.ed_id,f.ed_name)
                }}
                    placeholder={props.placeholder}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default GetWebGoodsSpec